import React from "react";
import Images from "../../../assets/images/index";
import { useNavigate } from "react-router-dom";
export default function SomethingWentWrong(props) {
    const navigate = useNavigate();
    const navigatePathName ='/' + props.pathName.split('/')[1]
    const navigateUrl = () => {
        navigate(navigatePathName)
    }
    return(
        <div className="no_data_found_wrapper something_went_wrong text-center mt-4">
            <img src={Images.NoData} alt="No Data" className="img-fluid"/>
            <div className="no_data_text">
                <h4>Oops, an error has been occured</h4>
                <p>Please click the button below to try again</p>
            </div>
            <div className="retry_btn">
                <button type="button" onClick={navigateUrl} className="btn btn_theme">Retry Now</button>
            </div>
        </div>
    )
}